import SectionHeader from '../../../Components/SectionHeader/SectionHeader';
import ImageText from '../../../Components/ImageText/ImageText';
import imgPlaceholder from '../../../assets/TimelinePlaceholder.png'
import NumberGrid from '../../../Components/NumberGrid/NumberGrid';
import ThreeDImageCarousel from '../../../Components/CircleCarousel/CircleCarousel';
import { Button } from 'react-bootstrap';
import Promoter from '../../../Components/Promoter/Promoter';
import imgHANSA_FLEX_SERBIA_Cylindercentre_04 from '../../../assets/CylinderCentre/HANSA_FLEX_SERBIA_Cylindercentre_04.webp'
import { useEffect } from 'react';
import CenterStage from '../../../Components/CenterStage/CenterStage';
import imgHANSA_FLEX_BRANCH_SERBIA_SUBOTICA from '../../../assets/Journey/HANSA_FLEX_BRANCH_SERBIA_SUBOTICA.webp'
import imgSubotica1 from '../../../assets/Branch/Cylinder/Cylinder1.jpg'
import imgSubotica2 from '../../../assets/Branch/Pneumatics.jpg'
import imgSubotica3 from '../../../assets/Branch/Production/Production_2.jpg'
import imgSubotica4 from '../../../assets/Branch/Cylinder/Cylinder7.jpg'


const Branch9 = () => {

    useEffect(() => {
        window.scrollTo(0, 0); // Scroll to top on component mount
    }, []);

    const carouselData = [
        {
            image: imgSubotica1,
        },
        {
            image: imgSubotica2,
        },
        {
            image: imgSubotica3,
        },
        {
            image: imgSubotica4,
        },
    ]
    return (
        <div>
            <CenterStage imageSrc={imgHANSA_FLEX_BRANCH_SERBIA_SUBOTICA} title={"Welcome to HANSA-FLEX Subotica"} paragraph={"Opened in 2023 with the intention to be closer to the customers from Northern Serbia, branch Subotica has very quickly attracted many customers from different fields, from construction, services, factories and many others. Just like the larger branches, this smaller one can fully service any customer whatever the problem is."}
                buttonName={"Contact us"} buttonLink={"/contact-us"}
            />

            <ThreeDImageCarousel items={carouselData} />


            <div className="text-center div-gray">
                <SectionHeader
                    title={"📞 At Your Service – We're Just a Call Away!"}
                    subtitle={"We’re here when you need us most. Whether it’s regular maintenance or an emergency situation, our team is available around the clock to provide expert hydraulic service and support."}
                />
                <Button variant="danger" className="ImageText-button m-2" href='/contact-us'>{("24h SERVICE")}</Button>
                <Button variant="danger" className="ImageText-button" href='/contact-us'>{("FLEXXPRESS 24h")}</Button>
                <br /><br /><br />
            </div>
        </div>
    )
}

export default Branch9